<template>
    <div>
        <bulletin />
        <chat ref="chat" :live="live" :user="user" />
    </div>
</template>

<script>
import Bulletin from '../Bulletin'
import Chat from '../Chat'
export default {
    components: { Bulletin, Chat },
    name: 'ChatTab',
    props: {
        live: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
